import { useState } from 'react';
import styled from 'styled-components';
import { fetchTaxingUnitPollQuestions } from '../../api/questions';
import FeedbackPanel from '../_components/feedbackPanel';
import ContactDetailTab from './ContactDetailTab';
import HearingsTab from './HearingsTab';
import HistoricalRateTab from './HistoricalRateTab';
import RatesTab from './RatesTab';
import Tab from './Tab';
import TaxLimitationTab, { hasTaxLimitation } from './TaxLimitationTab';

const RATES_TAB = 'Rates';
const HEARINGS_TAB = 'Hearings';
const CONTACT_TAB = 'Contact Details';
const HISTORICAL_TAB = 'Historical Tax Rates';
const TAX_LIMITATION_TAB = 'Tax Limitation';
const FEEDBACK_TAB = 'Feedback';
const tabs = [
  RATES_TAB,
  HEARINGS_TAB,
  CONTACT_TAB,
  HISTORICAL_TAB,
  TAX_LIMITATION_TAB,
  FEEDBACK_TAB,
];

const UnitWrapper = ({
  unit,
  buildLineChartConfig,
  isUseTaxElectionRate,
  isWaterRate,
  openWorksheetPDF,
  parseFloatKeep,
  showLastYearTaxes,
  showNotPublishedForZeroTaxRate,
  openHearingWindow,
  fetchTaxingUnit,
  showBudgetInformation,
  showHistoricalTaxRates,
  buildLineHChartConfig,
  params,
  fetchHistoricalRates,
  taxpayerFeedbackEnabled,
  apiBaseUrl,
  token,
  submitFeedack,
  pushToast,
  showLegislativeExemptionDisclaimer,
  legislativeExemptionDisclaimer,
  ownerId,
}) => {
  const [currentTab, setCurrentTab] = useState(0);
  const getFilteredTabs = () =>
    tabs.filter((t) => {
      if (t === HISTORICAL_TAB) {
        return Boolean(showHistoricalTaxRates);
      }
      if (t === TAX_LIMITATION_TAB) {
        return hasTaxLimitation(unit);
      }
      return true;
    });

  const renderContent = (tab) => {
    switch (tab) {
      case RATES_TAB:
        return (
          <RatesTab
            buildLineChartConfig={buildLineChartConfig}
            isUseTaxElectionRate={isUseTaxElectionRate}
            isWaterRate={isWaterRate}
            openWorksheetPDF={openWorksheetPDF}
            parseFloatKeep={parseFloatKeep}
            showLastYearTaxes={showLastYearTaxes}
            showNotPublishedForZeroTaxRate={showNotPublishedForZeroTaxRate}
            unit={unit}
          />
        );
      case HEARINGS_TAB:
        return (
          <HearingsTab openHearingWindow={openHearingWindow} unit={unit} />
        );
      case CONTACT_TAB:
        return (
          <ContactDetailTab
            fetchTaxingUnit={fetchTaxingUnit}
            openWorksheetPDF={openWorksheetPDF}
            showBudgetInformation={showBudgetInformation}
            unit={unit}
          />
        );
      case HISTORICAL_TAB:
        return (
          <HistoricalRateTab
            buildLineChartConfig={buildLineChartConfig}
            buildLineHChartConfig={buildLineHChartConfig}
            fetchHistoricalRates={fetchHistoricalRates}
            isUseTaxElectionRate={isUseTaxElectionRate}
            isWaterRate={isWaterRate}
            ownerId={ownerId}
            propertyID={params.propertyId}
            unit={unit}
          />
        );
      case TAX_LIMITATION_TAB:
        return <TaxLimitationTab parseFloatKeep={parseFloatKeep} unit={unit} />;
      case FEEDBACK_TAB:
        return taxpayerFeedbackEnabled ? (
          <FeedbackPanel
            fetchTaxingUnitPollQuestions={fetchTaxingUnitPollQuestions.bind(
              null,
              apiBaseUrl,
              token,
            )}
            handleSubmit={(data) =>
              submitFeedack({
                ...data,
                selectedUnitId: unit.taxingUnitID,
                selectedUnitYear: unit.taxingUnitYr,
                selectedProperty: unit.propID,
              })
            }
            pushToast={pushToast}
            unitId={unit.taxingUnitID}
            year={unit.taxingUnitYr}
          />
        ) : null;
      default:
        return null;
    }
  };

  const showDisclaimer = Boolean(
    showLegislativeExemptionDisclaimer &&
      unit &&
      unit.taxingUnitType === 'School',
  );
  const showDisclaimerText = legislativeExemptionDisclaimer;
  return (
    <div className='custom-container'>
      <div className='title'>
        <span>{unit.taxingUnitName}</span>
        <span className='taxing-code'>
          Taxing Unit Code: {unit.taxingUnitCode}
        </span>
      </div>
      <div className='tax-wrapper'>
        <Tab
          currentTab={currentTab}
          renderContent={renderContent}
          setCurrentTab={(tab) => setCurrentTab(tab)}
          tabs={getFilteredTabs()}
        />
      </div>
      {showDisclaimer ? (
        <LegislativeExemptionDisclaimer
          // biome-ignore lint/security/noDangerouslySetInnerHtml: rich-text message authored by CAD admins in client config
          dangerouslySetInnerHTML={{
            __html: showDisclaimerText ? showDisclaimerText : '',
          }}
        />
      ) : null}
    </div>
  );
};

const LegislativeExemptionDisclaimer = styled.div`
  padding: 15px 30px 15px 15px;
  background-color: #fdcd3c;
  font-weight: normal;

  p {
    margin: 0;
  }
`;

export default UnitWrapper;
